/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Reason_Reviewed_TextInputs */



/**
* | output |
* | --- |
* | "Each report is checked in house for accuracy and clarity before it reaches you." |
*
* @param {Home_Reason_Reviewed_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_reason_reviewed_text = /** @type {((inputs?: Home_Reason_Reviewed_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Reason_Reviewed_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("每份报告在交给您之前，都会由内部团队审核其准确性和清晰度。")
	return /** @type {LocalizedString} */ ("Each report is checked in house for accuracy and clarity before it reaches you.")
});